import { useAuth } from '../../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Link } from 'react-router-dom';
import {
    User,
    Mail,
    Phone,
    Shield,
    LifeBuoy,
    Heart,
    LogOut
} from 'lucide-react';

export default function CustomerProfile() {
    const { customer, logout } = useAuth();

    if (!customer) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p>Please login to view your profile.</p>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto px-6 py-8">
            <h1 className="text-2xl font-heading font-bold text-navy-900 mb-6">My Profile</h1>

            <div className="grid md:grid-cols-3 gap-6">
                {/* Profile Details */}
                <div className="md:col-span-2 space-y-6">
                    <Card>
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <User className="w-5 h-5 text-sky-500" />
                                Personal Information
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-4">
                            <div className="grid sm:grid-cols-2 gap-4">
                                <div>
                                    <label className="text-sm text-navy-500">Full Name</label>
                                    <p className="font-medium text-navy-900 text-lg">{customer.name}</p>
                                </div>
                                <div>
                                    <label className="text-sm text-navy-500">Email Address</label>
                                    <p className="font-medium text-navy-900 flex items-center gap-2">
                                        <Mail className="w-4 h-4 text-navy-400" />
                                        {customer.email}
                                    </p>
                                </div>
                                <div>
                                    <label className="text-sm text-navy-500">Phone Number</label>
                                    <p className="font-medium text-navy-900 flex items-center gap-2">
                                        <Phone className="w-4 h-4 text-navy-400" />
                                        {customer.phone || 'Not provided'}
                                    </p>
                                </div>
                                <div>
                                    <label className="text-sm text-navy-500">Account Type</label>
                                    <p className="font-medium text-navy-900 flex items-center gap-2">
                                        <Shield className="w-4 h-4 text-navy-400" />
                                        Customer Account
                                    </p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>

                {/* Quick Links */}
                <div className="space-y-6">
                    <Card>
                        <CardHeader>
                            <CardTitle>Quick Actions</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-3">
                            <Link to="/customer/favorites">
                                <Button variant="outline" className="w-full justify-start gap-3">
                                    <Heart className="w-4 h-4 text-red-500" />
                                    My Favorites
                                </Button>
                            </Link>
                            <Link to="/customer/tickets">
                                <Button variant="outline" className="w-full justify-start gap-3">
                                    <LifeBuoy className="w-4 h-4 text-blue-500" />
                                    Support Tickets
                                </Button>
                            </Link>
                            <Button
                                variant="ghost"
                                className="w-full justify-start gap-3 text-red-600 hover:text-red-700 hover:bg-red-50"
                                onClick={logout}
                            >
                                <LogOut className="w-4 h-4" />
                                Sign Out
                            </Button>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    );
}
